import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { type AxiosResponse } from 'axios';
import { type Coupon } from 'types/coupons';

const COUPONS_URL = `${BASE_URL}coupons`;

interface CouponsServiceTypes {
  getCoupons: (userId: string) => Promise<AxiosResponse<Coupon[]>>;
  createCoupon: (userId: string, body: Coupon) => Promise<AxiosResponse<{ couponCode: string }>>;
}

export const CouponsService: CouponsServiceTypes = {
  getCoupons: userId => service.get(`${COUPONS_URL}/${userId}`),
  createCoupon: async (userId, body) => service.post(`${COUPONS_URL}/patients/${userId}`, body),
};
